import type { TemplateSummary } from "../../api/promptTemplates";

export type TemplateSort = "name" | "category" | "newest";

export function filterTemplates(
  items: TemplateSummary[],
  query: string,
  language: "all" | "en" | "es" | "hi",
): TemplateSummary[] {
  const q = query.trim().toLowerCase();
  return items.filter((t) => {
    if (language !== "all" && t.language !== language) return false;
    if (!q) return true;
    return (t.name + " " + t.description + " " + t.suggested_role).toLowerCase().includes(q);
  });
}

export function sortTemplates(items: TemplateSummary[], sort: TemplateSort): TemplateSummary[] {
  const out = [...items];
  if (sort === "name") out.sort((a, b) => a.name.localeCompare(b.name));
  else if (sort === "category")
    out.sort((a, b) => a.category.localeCompare(b.category) || a.name.localeCompare(b.name));
  else if (sort === "newest")
    out.sort((a, b) => (b.created_at ?? "").localeCompare(a.created_at ?? ""));
  return out;
}
